<template>
  <div>
    <a-modal
      :visible="visible"
      @cancel="handleClose"
      :footer="null"
      :centered="true"
    >
      <div class="content2Login">
        <div class="word"><span>密码登录</span></div>
        <div class="account">
          <div class="emailTip">登录账号</div>
          <div class="email">
            <a-input
              class="custom-placeholder"
              placeholder="请输入您的账号"
              size="large"
              v-model="account"
            ></a-input>
          </div>
          <div class="passwordTip">输入密码</div>
          <div class="password">
            <a-input-password
              placeholder="请输入6-30位密码"
              v-model="password"
              type="password"
              size="large"
            ></a-input-password>
          </div>
          <div class="verifyCode" v-show="needVerifyCode">
            <a-input placeholder="请输入验证码" v-model="verifyCode"></a-input>
            <div class="imgCode">
              <img
                :src="imgUrl + '&random=' + randoms"
                alt=""
                @click="randoms = Math.random()"
              />
            </div>
          </div>
        </div>
        <div class="loginBtn">
          <a-button type="primary" size="large" block @click="login"
            >立即登录</a-button
          >
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { messageTips, setCookie, getCookie, delCookie } from "@/until/tools";
import config from "@/until/configs";

export default {
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      password: "",
      account: "",
      needVerifyCode: false,
      verifyCode: "",
      imgUrl: "",
      randoms: "",
    };
  },
  methods: {
    login() {
      if (this.account === "") {
        messageTips("请输入账号", 2);
        return false;
      }
      if (this.password === "") {
        messageTips("请输入密码", 2);
        return false;
      }
      let params = {
        account: this.account,
        verifyCode: this.verifyCode,
        password: this.password,
      };
      this.$http.isNeedVerifyCode({ account: params.account }).then((res) => {
        if (res.needVerifyCode) {
          this.needVerifyCode = true;
          if (this.verifyCode === "") {
            messageTips("请输入验证码", 2);
            this.$http.getSign({ account: this.account }).then((res) => {
              if (res) {
                if (res.sign) {
                  this.imgUrl =
                    config.imgCode +
                    "?account=" +
                    this.account +
                    "&sign" +
                    res.sign;
                }
              }
            });
            return false;
          } else {
            params.imageCode = this.verifyCode;
            this.continueLogin(params);
          }
        } else {
          this.continueLogin(params);
        }
      });
    },
    continueLogin(params) {
      this.$http.login(params).then((res) => {
        if (res) {
          if (res.sid) {
            setCookie("bd_sid", res.sid, { time: 1 });
            let loginTargetUrl = getCookie("loginTargetUrl");
            if (loginTargetUrl) {
              this.$router.push({ path: loginTargetUrl });
              delCookie("loginTargetUrl");
            } else {
              this.$router.push("/newHome/newIndex");
            }
            this.handleClose();
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    },
    //登录弹框
    handleClose() {
      this.$emit("close");
      this.account = "";
      this.verifyCode = "";
      this.password = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.content2Login {
  overflow: hidden;
  .word {
    margin-top: 40px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 20px;
    color: #333333;
    line-height: 10px;
    span {
      display: inline-block;
      padding-bottom: 18px;
      border-bottom: 2px solid #f7c239;
    }
  }
  .account {
    .custom-placeholder::placeholder {
      font-size: 14px;
      color: #999;
    }
    .emailTip {
      color: #333;
      margin-top: 30px;
      font-size: 15px;
    }
    .email {
      margin-top: 15px;
    }
    .passwordTip {
      margin: 20px auto 15px;
    }
    .password {
      /deep/input::placeholder {
        font-size: 14px;
        color: #999;
      }
    }
    .verifyCode {
      margin-top: 20px;
      /deep/ input {
        height: 40px;
        width: 240px;
      }
      .imgCode {
        width: 100px;
        float: right;
        height: 40px;
        background: skyblue;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .loginBtn {
    width: 100%;
    margin: 40px auto 24px;
    button {
      background: #4f4f4f;
      border: none;
    }
  }
}
</style>
